import clsx from 'clsx';
import React from 'react';

import { FLEX_SCROLL_CLASS } from './constants';
import useFlexScrollStyles from './styles';
import { FlexScrollProps } from './types';

const FlexScroll: React.ForwardRefExoticComponent<FlexScrollProps> = React.forwardRef<
  HTMLDivElement,
  FlexScrollProps
>((props, ref) => {
  const { children, className } = props;
  const classes = useFlexScrollStyles(props);
  const renderFlexScroll = () => {
    return (
      <div className={clsx(classes.scrollWrapper, className)}>
        <div className={clsx(classes.flexScroll, FLEX_SCROLL_CLASS)} ref={ref}>
          {children}
        </div>
      </div>
    );
  };

  return renderFlexScroll();
});

export default FlexScroll;
